import {
	Box,
	Divider,
	Grid,
	List,
	ListItem,
	ListItemText,
	Paper,
	Typography,
} from "@material-ui/core";
import { ExportServerPDFButton } from "components/dialogs/ExportDialog/ExportServerButton";
import { DateTimeField } from "components/fields/DateFormatField";
import { formatDateTime } from "components/inputs";
import { OrderService } from "entities/OrderService";
import React from "react";
import { formatWeight } from "utils/weight";

export const PalletDetails = ({
	translate,
	classes,
	selectedPallet,
	selectedBox,
	handleBoxClick,
	order,
}) => {
	if (!selectedPallet) {
		return <Typography>{translate("tab.pallets.no_pallet_selected")}</Typography>;
	}
	return (
		<Box>
			<Box>
				<Typography variant="h6" className={classes.sectionTitle}>
					{translate("tab.pallets.pallet_information")}
				</Typography>

				<Grid container spacing={2}>
					<Grid item xs={12} md={4}>
						<Paper className={classes.infoCard} style={{ padding: "16px" }}>
							<Typography
								variant="subtitle1"
								gutterBottom
								color="primary"
								style={{ fontSize: "1rem", fontWeight: 600 }}
							>
								{translate("tab.pallets.basic_details")}
							</Typography>

							<Box className={classes.infoRow} style={{ marginBottom: "8px" }}>
								<Typography
									className={classes.infoLabel}
									style={{ fontSize: "0.875rem", fontWeight: 500, color: "#333" }}
								>
									{translate("tab.pallets.id")}:
								</Typography>
								<Typography
									className={classes.infoValue}
									style={{ fontSize: "0.875rem", color: "#000" }}
								>
									{selectedPallet.id}
								</Typography>
							</Box>

							<Box className={classes.infoRow} style={{ marginBottom: "8px" }}>
								<Typography
									className={classes.infoLabel}
									style={{ fontSize: "0.875rem", fontWeight: 500, color: "#333" }}
								>
									{translate("tab.pallets.sscc")}:
								</Typography>
								<Typography
									className={classes.infoValue}
									style={{ fontSize: "0.875rem", color: "#000" }}
								>
									{selectedPallet.sscc || "N/A"}
								</Typography>
							</Box>

							<Box className={classes.infoRow} style={{ marginBottom: "8px" }}>
								<Typography
									className={classes.infoLabel}
									style={{ fontSize: "0.875rem", fontWeight: 500, color: "#333" }}
								>
									{translate("tab.pallets.gtin")}:
								</Typography>
								<Typography
									className={classes.infoValue}
									style={{ fontSize: "0.875rem", color: "#000" }}
								>
									{selectedPallet.gtin || "N/A"}
								</Typography>
							</Box>

							<Box className={classes.infoRow} style={{ marginBottom: "8px" }}>
								<Typography
									className={classes.infoLabel}
									style={{ fontSize: "0.875rem", fontWeight: 500, color: "#333" }}
								>
									{translate("tab.pallets.quantity")}:
								</Typography>
								<Typography
									className={classes.infoValue}
									style={{ fontSize: "0.875rem", color: "#000" }}
								>
									{selectedPallet.quantity || "N/A"}
								</Typography>
							</Box>

							<Box className={classes.infoRow} style={{ marginBottom: "8px" }}>
								<Typography
									className={classes.infoLabel}
									style={{ fontSize: "0.875rem", fontWeight: 500, color: "#333" }}
								>
									{translate("tab.pallets.weight")}:
								</Typography>
								<Typography
									className={classes.infoValue}
									style={{ fontSize: "0.875rem", color: "#000" }}
								>
									{formatWeight(selectedPallet.net_weight, selectedPallet.weight_unit_code)}
								</Typography>
							</Box>
						</Paper>
					</Grid>

					<Grid item xs={12} md={4}>
						<Paper className={classes.infoCard} style={{ padding: "16px" }}>
							<Typography
								variant="subtitle1"
								gutterBottom
								color="primary"
								style={{ fontSize: "1rem", fontWeight: 600 }}
							>
								{translate("tab.pallets.dates_and_info")}
							</Typography>

							<Box className={classes.infoRow} style={{ marginBottom: "8px" }}>
								<Typography
									className={classes.infoLabel}
									style={{ fontSize: "0.875rem", fontWeight: 500, color: "#333" }}
								>
									{translate("tab.pallets.production")}:
								</Typography>
								<DateTimeField
									source="production_datetime"
									withLocalTimeZone
									record={selectedPallet}
								/>
							</Box>

							<Box className={classes.infoRow} style={{ marginBottom: "8px" }}>
								<Typography
									className={classes.infoLabel}
									style={{ fontSize: "0.875rem", fontWeight: 500, color: "#333" }}
								>
									{translate("tab.pallets.expiration")}:
								</Typography>
								<DateTimeField
									source="expiration_datetime"
									withLocalTimeZone
									record={selectedPallet}
								/>
							</Box>

							<Box className={classes.infoRow} style={{ marginBottom: "8px" }}>
								<Typography
									className={classes.infoLabel}
									style={{ fontSize: "0.875rem", fontWeight: 500, color: "#333" }}
								>
									{translate("tab.pallets.pallet")} #:
								</Typography>
								<Typography
									className={classes.infoValue}
									style={{ fontSize: "0.875rem", color: "#000" }}
								>
									{selectedPallet.number_of_pallet || "N/A"} of{" "}
									{selectedPallet.total_number_of_pallet || "N/A"}
								</Typography>
							</Box>

							<Box className={classes.infoRow} style={{ marginBottom: "8px" }}>
								<Typography
									className={classes.infoLabel}
									style={{ fontSize: "0.875rem", fontWeight: 500, color: "#333" }}
								>
									{translate("tab.pallets.external_id")}:
								</Typography>
								<Typography
									className={classes.infoValue}
									style={{ fontSize: "0.875rem", color: "#000" }}
								>
									{selectedPallet.ext_id ?? "N/A"}
								</Typography>
							</Box>
						</Paper>
					</Grid>

					{(selectedPallet.product_number || selectedPallet.product_name) && (
						<Grid item xs={12} md={4}>
							<Paper className={classes.infoCard} style={{ padding: "16px" }}>
								<Typography
									variant="subtitle1"
									gutterBottom
									color="primary"
									style={{ fontSize: "1rem", fontWeight: 600 }}
								>
									{translate("tab.pallets.product_info")}
								</Typography>

								<Box className={classes.infoRow} style={{ marginBottom: "8px" }}>
									<Typography
										className={classes.infoLabel}
										style={{ fontSize: "0.875rem", fontWeight: 500, color: "#333" }}
									>
										{translate("tab.pallets.code")}:
									</Typography>
									<Typography
										className={classes.infoValue}
										style={{ fontSize: "0.875rem", color: "#000" }}
									>
										{selectedPallet.product_number || "N/A"}
									</Typography>
								</Box>

								<Box className={classes.infoRow} style={{ marginBottom: "8px" }}>
									<Typography
										className={classes.infoLabel}
										style={{ fontSize: "0.875rem", fontWeight: 500, color: "#333" }}
									>
										{translate("tab.pallets.product_name")}:
									</Typography>
									<Typography
										className={classes.infoValue}
										style={{ fontSize: "0.875rem", color: "#000", wordBreak: "break-word" }}
									>
										{selectedPallet.product_name || "N/A"}
									</Typography>
								</Box>
							</Paper>
						</Grid>
					)}

					{selectedPallet?.ext_product_attributes && (
						<Grid item xs={12} md={6}>
							<Paper className={classes.infoCard} style={{ padding: "16px" }}>
								<Typography
									variant="subtitle1"
									gutterBottom
									color="primary"
									style={{ fontSize: "1rem", fontWeight: 600 }}
								>
									{translate("tab.pallets.product_attributes")}
								</Typography>
								<Box
									display="grid"
									gridTemplateColumns="repeat(auto-fit, minmax(140px, 1fr))"
									gap={1.5}
								>
									{Object.entries(selectedPallet.ext_product_attributes).map(([key, value]) => (
										<Box key={key}>
											<Typography
												variant="caption"
												color="textSecondary"
												style={{ fontSize: "0.8rem", fontWeight: 500, color: "#555" }}
											>
												{key.replace(/_/g, " ").replace(/\b\w/g, (l) => l.toUpperCase())}
											</Typography>
											<Typography
												variant="body2"
												style={{ fontSize: "0.875rem", lineHeight: 1.3, color: "#000" }}
											>
												{value ?? "N/A"}
											</Typography>
										</Box>
									))}
								</Box>
							</Paper>
						</Grid>
					)}

					{selectedPallet?.ext_pallet_attributes && (
						<Grid item xs={12} md={6}>
							<Paper className={classes.infoCard} style={{ padding: "16px" }}>
								<Typography
									variant="subtitle1"
									gutterBottom
									color="primary"
									style={{ fontSize: "1rem", fontWeight: 600 }}
								>
									{translate("tab.pallets.pallet_attributes")}
								</Typography>
								<Box
									display="grid"
									gridTemplateColumns="repeat(auto-fit, minmax(140px, 1fr))"
									gap={1.5}
								>
									{Object.entries(selectedPallet.ext_pallet_attributes).map(([key, value]) => (
										<Box key={key}>
											<Typography
												variant="caption"
												color="textSecondary"
												style={{ fontSize: "0.8rem", fontWeight: 500, color: "#555" }}
											>
												{key.replace(/_/g, " ").replace(/\b\w/g, (l) => l.toUpperCase())}
											</Typography>
											<Typography
												variant="body2"
												style={{ fontSize: "0.875rem", lineHeight: 1.3, color: "#000" }}
											>
												{value ?? "N/A"}
											</Typography>
										</Box>
									))}
								</Box>
							</Paper>
						</Grid>
					)}
				</Grid>
			</Box>
			<Box mt={4}>
				<Typography variant="h5" className={classes.sectionTitle}>
					{translate("tab.pallets.related_boxes")} ({selectedPallet?.boxes?.length || 0})
				</Typography>

				{selectedPallet?.boxes?.length > 0 ? (
					<List className={classes.boxList}>
						{selectedPallet.boxes.map((box, index) => (
							<React.Fragment key={box.id}>
								<ListItem
									className={classes.boxItem}
									onClick={() => handleBoxClick(box)}
									selected={selectedBox?.id === box.id}
									alignItems="flex-start"
								>
									<ListItemText
										primary={
											<Typography variant="subtitle1" style={{ fontWeight: 600 }}>
												{translate("tab.pallets.box")} {box.sscc || box.id}
											</Typography>
										}
										secondary={
											<Box
												display="grid"
												gridTemplateColumns="repeat(auto-fit, minmax(180px, 1fr))"
												gap={1}
												mt={1}
											>
												{order.service === OrderService.coldStorage ? (
													<ExportServerPDFButton
														endpoint={`boxes/${box.id}/label`}
														label={translate("osfc.buttons.label")}
													/>
												) : null}
												{Object.entries(box)
													.filter(
														([key]) =>
															![
																"ext_product_attributes",
																"ext_box_attributes",
																"reserved_order_id",
																"id",
															].includes(key)
													)
													.map(([key, value]) => {
														const translatedKey = translate(`tab.pallets.${key}`);

														return (
															<Box key={key}>
																<Typography variant="caption" style={{ color: "#000" }}>
																	{translatedKey}
																</Typography>
																<Typography variant="body2" style={{ color: "#000" }}>
																	{value !== null && value !== undefined ? String(value) : "—"}
																</Typography>
															</Box>
														);
													})}
											</Box>
										}
									/>
								</ListItem>
								{index < selectedPallet.boxes.length - 1 && <Divider />}
							</React.Fragment>
						))}
					</List>
				) : (
					<Typography>{translate("tab.pallets.no_boxes_found")}</Typography>
				)}
			</Box>
		</Box>
	);
};
